// Imports
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StyleSheetManager } from 'styled-components/macro';
import App from './app';
import store from './shareables/foundation/front-end/redux/store';
import setUp from './shareables/foundation/front-end/utils/set-up';


// Set up
setUp();


// Disable Plausible if not in production
if (process.env.REACT_APP__ENVIRONMENT !== 'production') {
	localStorage.setItem('plausible_ignore', 'true');
}


// Mount and render
//  -> `disableCSSOMInjection` prevents corrupting styles during prerendering
const container = document.getElementById('root');

if (!container) {
	throw new Error('Root container should exist');
}

const app = (
	<StyleSheetManager disableCSSOMInjection={window.IS_PRERENDERING}>
		<Provider store={store}>
			<App />
		</Provider>
	</StyleSheetManager>
);

if (container.hasChildNodes()) {
	ReactDOM.hydrate(app, container);
} else {
	ReactDOM.render(app, container);
}
